var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c("div", { class: _vm.slideInClass }, [
        _c(
          "header",
          { class: { titled: _vm.hasTitle } },
          [
            _vm.hasTitle
              ? _c("div", [
                  _c("h4", { domProps: { innerHTML: _vm._s(_vm.title) } })
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "close-container" }, [
              _c(
                "a",
                {
                  attrs: { href: "#" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.close(false)
                    }
                  }
                },
                [_c("Icon", { attrs: { icon: "close" } })],
                1
              )
            ]),
            _vm._v(" "),
            _vm.jonInfo
              ? _c("JonInfo", {
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "message",
                        fn: function() {
                          return [
                            _vm.jonInfo === _vm.jonInfos.botCollege
                              ? _c("div", [
                                  _vm._v(
                                    "\n\t\t\t\t\tGib bitte deine abgeschlossene "
                                  ),
                                  _c("b", [_vm._v("Hochschulausbildung")]),
                                  _vm._v(" ein.\n\t\t\t\t\t"),
                                  _c("br"),
                                  _c("br"),
                                  _vm._v(
                                    "\n\t\t\t\t\tSolltest du mehrere haben, dann gib die für dich wichtigste ein. Später kannst du noch\n\t\t\t\t\tweitere eingeben.\n\t\t\t\t"
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.jonInfo === _vm.jonInfos.botHighSchool
                              ? _c("div", [
                                  _vm._v(
                                    "\n\t\t\t\t\tGib bitte deine abgeschlossene "
                                  ),
                                  _c("b", [_vm._v("Schulausbildung")]),
                                  _vm._v(" ein.\n\t\t\t\t\t"),
                                  _c("br"),
                                  _c("br"),
                                  _vm._v(
                                    "\n\t\t\t\t\tSolltest du mehrere haben, dann gib die für dich wichtigste ein. Später kannst du noch\n\t\t\t\t\tweitere eingeben.\n\t\t\t\t"
                                  )
                                ])
                              : _vm._e()
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    324391499
                  )
                })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "main",
          { staticClass: "scrollbar-check" },
          [
            _c("Edit", {
              attrs: {
                meta: _vm.meta,
                "with-school-type-selection": _vm.withSchoolTypeSelection,
                "with-details": _vm.withDetails
              },
              model: {
                value: _vm.education,
                callback: function($$v) {
                  _vm.education = $$v
                },
                expression: "education"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "footer",
          [
            _c("Button", {
              attrs: {
                text: _vm.education
                  ? "Ausbildung speichern"
                  : "Ausbildung hinzufügen",
                disabled: !_vm.education,
                icon: "checkmark"
              },
              on: { click: _vm.educationSaved }
            })
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }